import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledRightArrowIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 13 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.4151 6.17675C13.195 6.63142 13.195 7.36858 12.4151 7.82326L1.40914 13.6567C0.151084 14.3901 3.47369e-07 13.8707 3.92708e-07 12.8334L-5.09934e-08 1.16659C-5.65401e-09 0.129348 0.151086 -0.390105 1.40915 0.343337L12.4151 6.17675Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgFilledRightArrowIcon);
const Memo = memo(ForwardRef);
export default Memo;
